module.exports = __webpack_public_path__ + "media/images/plans/wedding_compact/dress-9cd76ba819cfe9e57edc624a4052c51e.jpg";